import axios from 'axios';
import {actions} from '../reducers/ContactsReducer';

export const CONTACTS_LIST = '/contacts/getContacts';
export const CONTACTS_LIST_FOR_EXCEL = '/contacts/getListForExcel';
export const GET_CONTACT_DATA = '/contacts/getContactData';
export const ADD_EDIT_CONTACT = '/contacts/addEditContact';
export const DELETE_CONTACT = '/contacts/deleteContact';
export const RESTORE_CONTACT = '/contacts/undeleteContact';
export const CHECK_PHONE = '/contacts/checkIfContactPhoneExists';
export const CHECK_EMAIl = '/contacts/checkIfContactEmailExists';

export const getContactsList = action => ({
                                            name = '',
                                            phone = '',
                                            job = '',
                                            organization = '',
                                            email = '',
                                            statusID = -1,
                                            deleted = 0,
                                            requestedPageNumber = 0,
                                            sortByField = 'contactID',
                                            sortByOrder = -1
                                          }) => dispatch => {

  const data = {
    name,
    phone,
    job,
    organization,
    email,
    statusID: parseInt(statusID, 10),
    deleted: deleted ? 1 : 0,
    requestedPageNumber: parseInt(requestedPageNumber, 10),
    sortByField,
    sortByOrder: parseInt(sortByOrder, 10),
  };

  return axios.post(CONTACTS_LIST, data)
    .then(response => {
      const {errorCode, body} = response.data;
      if (errorCode < 0) throw new Error();
      dispatch(action(body));
    })
    .catch(error => {
      error.clientMessage = 'Can\'t find data';
      dispatch(actions.catchError(error));
    });
};

export const getContactsListForExcel = ({
                                          name = '',
                                          phone = '',
                                          job = '',
                                          organization = '',
                                          email = '',
                                          statusID = -1,
                                          deleted = 0,
                                          sortByField = 'contactID',
                                          sortByOrder = -1
                                        }) => dispatch => {
  const data = {
    name,
    phone,
    job,
    organization,
    email,
    statusID: parseInt(statusID, 10),
    deleted: deleted ? 1 : 0,
    sortByField,
    sortByOrder: parseInt(sortByOrder, 10),
  };
  return axios.post(CONTACTS_LIST_FOR_EXCEL, data)
    .then(response => {
      const {errorCode, body} = response.data;
      if (errorCode < 0) throw new Error();

      return body.list;
    })
    .catch(error => {
      error.clientMessage = 'Can\'t find data';
      dispatch(actions.catchError(error));
    });
};

export const addEditContact = ({
                                 contactID,
                                 firstName,
                                 lastName,
                                 phone,
                                 email,
                                 address,
                                 organization,
                                 job,
                                 statusID
                               }, updateGrid = false) => (dispatch) => {

  const data = {
    contactID: parseInt(contactID, 10),
    firstName,
    lastName,
    phone,
    email,
    address,
    organization,
    job,
    statusID: parseInt(statusID, 10),
  };

  return axios.post(ADD_EDIT_CONTACT, data)
    .then(response => {
      const {errorCode, body} = response.data;
      if (errorCode < 0) throw new Error();
      if (updateGrid) {
        if (data.contactID === -1) {
          dispatch(actions.addContact(body.contactData));
        } else {
          dispatch(actions.editContact(body.contactData));
        }
      }

      return body?.contactData ? body.contactData : [];
    });
};

export const getContactData = (contactID) => {

  return axios.post(GET_CONTACT_DATA, {contactID})
    .then(response => {
      const {errorCode, body} = response.data;
      if (errorCode < 0) throw new Error();
      const {contactData} = body;

      return contactData;
    })
    .catch(error => {
      error.clientMessage = 'Can\'t find data';
    });
};

export const deleteContact = (contactID) => dispatch => {

  return axios.post(DELETE_CONTACT, {contactID})
    .then(response => {
      const {errorCode} = response.data;

      if (errorCode === 0) {
        dispatch(actions.deleteContact({contactID}));
      } else {
        throw new Error();
      }

      return errorCode;
    })
    .catch(error => {
      error.clientMessage = 'Can\'t delete contact';
    });
};

export const restoreContact = (contactID) => dispatch => {

  return axios.post(RESTORE_CONTACT, {contactID})
    .then(response => {
      const {errorCode} = response.data;

      if (errorCode === 0) {
        dispatch(actions.restoreContact({contactID}));
      } else {
        throw new Error();
      }

      return errorCode;
    })
    .catch(error => {
      error.clientMessage = 'Can\'t restore contact';
    });
};

export const isContactPhoneExists = (phone) => {
  return axios.post(CHECK_PHONE, {phone})
    .then(response => {
      const {errorCode, body} = response.data;

      if (errorCode < 0) {
        throw new Error();
      }

      return body?.phoneExists ? Boolean(body.phoneExists) : false;
    })
    .catch(error => {
      error.clientMessage = 'Can\'t check contact phone';
    });
};

export const isEmailExists = (email) => {
  return axios.post(CHECK_EMAIl, {email})
    .then(response => {
      const {errorCode, body} = response.data;

      if (errorCode < 0) {
        throw new Error();
      }

      return body?.emailExists ? Boolean(body.emailExists) : false;
    })
    .catch(error => {
      error.clientMessage = 'Can\'t check contact phone';
    });
};

export const getContacts = getContactsList(actions.contactsFetched);
export const getNextContacts = getContactsList(actions.contactsAppended);
